import { Mission } from '~/landing/type'

export interface MathRecipeItemProps {
  step: number
  icon: string
  iconClassName?: string
  title: string
  description: string
}

export const MathRecipeSteps: MathRecipeItemProps[] = [
  {
    step: 1,
    icon: 'landing/book-v2.png',
    title: 'mathRecipe.chooseGradeAndTopic.title',
    description: 'mathRecipe.chooseGradeAndTopic.description',
    iconClassName: 'mt-2',
  },
  {
    step: 2,
    icon: 'landing/brain-v2.png',
    title: 'mathRecipe.personalizedLearning.title',
    description: 'mathRecipe.personalizedLearning.description',
    iconClassName: '-mt-0.5',
  },
  {
    step: 3,
    icon: 'landing/play-v2.png',
    title: 'mathRecipe.watchBiteSizedVideos.title',
    description: 'mathRecipe.watchBiteSizedVideos.description',
    iconClassName: '-mt-2 p-2',
  },
  {
    step: 4,
    icon: 'landing/dragon-v2.png',
    title: 'mathRecipe.haveFunWhileYouLearn.title',
    description: 'mathRecipe.haveFunWhileYouLearn.description',
    iconClassName: 'pt-1',
  },
  {
    step: 5,
    icon: 'landing/sheild-v2.png',
    title: 'mathRecipe.makeRealProgress.title',
    description: 'mathRecipe.makeRealProgress.description',
    iconClassName: '-mt-1 p-1',
  },
  {
    step: 6,
    icon: 'icons/products/test_prep_badge.png',
    title: 'mathRecipe.testYourself.title',
    description: 'mathRecipe.testYourself.description',
    iconClassName: 'p-1',
  },
]

export const MISSIONS: Mission[] = [
  { key: 'visionPage.missions.items.one', num: '01' },
  { key: 'visionPage.missions.items.two', num: '02' },
  { key: 'visionPage.missions.items.three', num: '03' },
  { key: 'visionPage.missions.items.four', num: '04' },
  { key: 'visionPage.missions.items.five', num: '05' },
  { key: 'visionPage.missions.items.six', num: '06' },
  { key: 'visionPage.missions.items.seven', num: '07' },
  { key: 'visionPage.missions.items.eight', num: '08' },
  { key: 'visionPage.missions.items.nine', num: '09' },
  { key: 'visionPage.missions.items.ten', num: '10' },
]
